import { showConfirmDialog } from '@jarvis/platform-ui';
import { formatLocalDate, formatLocalDateTime } from '../../../utils/timezone';
import { isTimeOffStartInPast } from './timeOffDateUtils';

function formatDraftStart(startLocal: Date, isAllDay: boolean): string {
  return isAllDay ? formatLocalDate(startLocal) : formatLocalDateTime(startLocal);
}

/** Warn when creating time off that starts in the past; returns false if the user cancels. */
export async function confirmPastTimeOffCreate(startLocal: Date, isAllDay: boolean): Promise<boolean> {
  if (!isTimeOffStartInPast(startLocal, isAllDay)) return true;

  const startLabel = formatDraftStart(startLocal, isAllDay);
  return showConfirmDialog({
    title: 'Past start date',
    message: `This time off starts in the past (${startLabel}). You can still create it — double-check the dates are correct.`,
    confirmText: 'Create anyway',
    cancelText: 'Go back'
  });
}
